import React from 'react';

import MainNav from './main-nav';
import AuthNav from './auth-nav';
import AddEvent from './add-event'
import '../css/nav-bar.css'
import EditEvent from './edit-event'

const NavBar = ({ setcurrentYear, currentYear, currentMonth, nameToDisplay, dateToDisplay, newUserName, newUserevent, isEditing, addevent, setisEditing, setnameToEdit, setdateToEdit, setidToEdit, nameToEdit, dateToEdit, idToEdit, changeSelectedMonth, updateevent, deleteevent }) => {


  return (
    <>
    <div id="nav-container">

    { (isEditing) ?  
    <EditEvent 
    setcurrentYear={setcurrentYear} currentYear={currentYear} currentMonth={currentMonth} 
    updateevent={updateevent} deleteevent={deleteevent} 
    changeSelectedMonth={changeSelectedMonth} nameToEdit={nameToEdit} 
    dateToEdit={dateToEdit} idToEdit={idToEdit} setnameToEdit={setnameToEdit} setdateToEdit={setdateToEdit} setidToEdit={setidToEdit} 
    setisEditing={setisEditing} isEditing={isEditing} /> 
    : 
    <AddEvent 
    setcurrentYear={setcurrentYear} currentYear={currentYear} currentMonth={currentMonth} 
    changeSelectedMonth={changeSelectedMonth} addevent={addevent} 
    newUserName={newUserName} newUserevent={newUserevent} nameToDisplay={nameToDisplay} dateToDisplay={dateToDisplay} />}
      {/* <AddEvent newUserName={newUserName} newUserevent={newUserevent} nameToDisplay={nameToDisplay} dateToDisplay={dateToDisplay} /> */}


      <nav>
      <MainNav />
      </nav>

      
      <nav className="authorization">
        <AuthNav />  
      </nav>



    </div>
    </>
  );
};

export default NavBar;